import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  ListDetailsEditorActionTypes,
  ListDetailsEditorActions,
} from './list-details-editor.actions';
import {
  LIST_DETAILS_EDITOR_INITIAL_STATE,
  ListDetailsEditorState,
} from './list-details-editor.state';

export function listDetailsEditorReducer(
  state: ListDetailsEditorState = LIST_DETAILS_EDITOR_INITIAL_STATE,
  action: ListDetailsEditorActions,
): ListDetailsEditorState {
  switch (action.type) {
    case ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SHOW_MODAL: {
      return {
        modalControl: ModalControlsSaveableFactory.show(),
      };
    }

    case ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE: {
      return {
        modalControl: ModalControlsSaveableFactory.saving(),
      };
    }

    case ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE_FAILED: {
      return {
        modalControl: ModalControlsSaveableFactory.errorSaving(
          action.payload.error,
        ),
      };
    }

    case ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_HIDE_MODAL:
    case ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE_SUCCEEDED: {
      return LIST_DETAILS_EDITOR_INITIAL_STATE;
    }

    default: {
      return state;
    }
  }
}
